type VideoDTO = {
  photo_id: number // 8278838
  title: string // 'soundv5'
  tree_id: number // 7340
  token: string // '979c917e3dc0a0c9fa12c6c21a6d49b5'
  promoted_p: boolean // true
  protected_p: boolean // false
  protection_method: string // ''
  protection_password?: string
  protection_individual_countries_p?: boolean // false
  protection_countries?: string // ""
  protection_endpoint?: string // ''
  protection_available_date?: string // ''
  protection_available_date_epoch?: number // 0
  protection_available_message?: string // ''
  protection_warning_date?: string // ''
  protection_warning_date_epoch?: number // 0
  protection_warning_message?: string // ''
  protection_expiration_date?: string // ''
  protection_expiration_date_epoch?: number // 0
  protection_expiration_message?: string // ''
  album_id: number // 4833724
  album_title: string // 'Webinars'
  album_hide_p: boolean // false
  all_albums: number | string // 4833724
  published_p: boolean // false
  one: string // '/soundv5-1'
  publish_date_ansi: string // ''
  publish_date_epoch: string // ''
  publish_date__date: string // ''
  publish_date__time: string // ''
  creation_date_ansi: string // '2022-12-13 17:19:26'
  creation_date_epoch: number // 1670951966.0
  creation_date__date: string // '13.12.2022'
  creation_date__time: string // '17:19'
  original_date_ansi: string // '2022-12-13 16:19:26'
  original_date__date: string // '13.12.2022'
  original_date__time: string // '16:19'
  view_count: number // 3
  avg_playtime: number // 38.90988759841438
  number_of_comments: number // 0
  number_of_albums: number // 1
  number_of_tags: number // 0
  photo_rating: string // ''
  number_of_ratings: number // 0
  video_p: boolean // true
  placeholder_p: boolean // false
  video_encoded_p: boolean // true
  video_360_p: boolean // false
  thumbnail_360_p: boolean // false
  audio_p: boolean // false
  video_length: number // 7
  video_length_float: number // 6.5
  video_length_fmt: string // '00:07'
  text_only_p: boolean // false
  user_id: number // 4701711
  username: string // '__hidden'
  display_name: string // 'Hidden User'
  user_url: string // '/user/__hidden/'
  has_deck_p: boolean // false
  has_external_url_p: boolean // false
  subtitles_p: boolean // false
  sections_p: boolean // false
  license_id: string // ''
  coordinates: string // ''
  absolute_url: string // 'https://demo.ranguinc.com/soundv5-1'
  video_hls_size: number // 1
  video_hls_download: string // '/7340/8278838/979c917e3dc0a0c9fa12c6c21a6d49b5/video_hls/playlist.m3u8?source='
  live_id: number // 8055176
  mischung_p: boolean // false
  mischung_template_p: boolean // false
  mischung_template_photo_id: string // ''
  mischung_template_icon: string // ''
  mischung_draft_p: boolean // false
  protected_token: string // ''
  user_profile_image_url: string // ''
  original_filename: string // ''
  original_width: number // 1920
  original_height: number // 1080
  original_size: number // 157336
  original_download: string // '/7340/8278838/979c917e3dc0a0c9fa12c6c21a6d49b5/original/soundv5-1-7-thumbnail.jpg'
  quad16_width: number // 75
  quad16_height: string // ''
  quad16_size: number // 2609
  quad16_download: string // '/7340/8278838/979c917e3dc0a0c9fa12c6c21a6d49b5/quad16/soundv5-1-7-thumbnail.jpg'
  quad50_width: number // 75
  quad50_height: string // ''
  quad50_size: number // 2609
  quad50_download: string // '/7340/8278838/979c917e3dc0a0c9fa12c6c21a6d49b5/quad50/soundv5-1-7-thumbnail.jpg'
  quad75_width: number // 75
  quad75_height: string // ''
  quad75_size: number // 2609
  quad75_download: string // '/7340/8278838/979c917e3dc0a0c9fa12c6c21a6d49b5/quad75/soundv5-1-7-thumbnail.jpg'
  quad100_width: number // 75
  quad100_height: string // ''
  quad100_size: number // 2609
  quad100_download: string // '/7340/8278838/979c917e3dc0a0c9fa12c6c21a6d49b5/quad100/soundv5-1-7-thumbnail.jpg'
  small_width: number // 75
  small_height: string // ''
  small_size: number // 2609
  small_download: string // '/7340/8278838/979c917e3dc0a0c9fa12c6c21a6d49b5/small/soundv5-1-7-thumbnail.jpg'
  medium_width: number // 75
  medium_height: string // ''
  medium_size: number // 2609
  medium_download: string // '/7340/8278838/979c917e3dc0a0c9fa12c6c21a6d49b5/medium/soundv5-1-7-thumbnail.jpg'
  portrait_width: number // 75
  portrait_height: string // ''
  portrait_size: number // 2609
  portrait_download: string // '/7340/8278838/979c917e3dc0a0c9fa12c6c21a6d49b5/portrait/soundv5-1-7-thumbnail.jpg'
  standard_width: number // 75
  standard_height: string // ''
  standard_size: number // 2609
  standard_download: string // '/7340/8278838/979c917e3dc0a0c9fa12c6c21a6d49b5/standard/soundv5-1-7-thumbnail.jpg'
  large_width: number // 75
  large_height: string // ''
  large_size: number // 2609
  large_download: string // '/7340/8278838/979c917e3dc0a0c9fa12c6c21a6d49b5/large/soundv5-1-7-thumbnail.jpg'
  video_medium_width: number // 640
  video_medium_height: number // 360
  video_medium_size: number // 249049
  video_medium_download: string // '/7340/8278838/979c917e3dc0a0c9fa12c6c21a6d49b5/video_medium/soundv5-1-7-video.mp4'
  video_hd_width: number // 1280
  video_hd_height: number // 720
  video_hd_size: number // 428038
  video_hd_download: string // '/7340/8278838/979c917e3dc0a0c9fa12c6c21a6d49b5/video_hd/soundv5-1-7-video.mp4'
  video_1080p_width: number // 1920
  video_1080p_height: number // 1080
  video_1080p_size: number // 671716
  video_1080p_download: string // '/7340/8278838/979c917e3dc0a0c9fa12c6c21a6d49b5/video_1080p/soundv5-1-7-video.mp4'
  video_4k_width: string // ''
  video_4k_height: string // ''
  video_4k_size: number // 0
  video_4k_download: string // ''
  video_frames_width: number // 320
  video_frames_height: number // 180
  video_frames_size: number // 93398
  video_frames_download: string // '/7340/8278838/979c917e3dc0a0c9fa12c6c21a6d49b5/video_frames/soundv5-1-7-frames.jpg'
  video_wmv_width: string // ''
  video_wmv_height: string // ''
  video_wmv_size: number // 0
  video_wmv_download: string // ''
  video_mobile_h263_amr_width: string // ''
  video_mobile_h263_amr_height: string // ''
  video_mobile_h263_amr_size: number // 0
  video_mobile_h263_amr_download: string // ''
  video_mobile_h263_aac_width: string // ''
  video_mobile_h263_aac_height: string // ''
  video_mobile_h263_aac_size: number // 0
  video_mobile_h263_aac_download: string // ''
  video_mobile_mpeg4_amr_width: string // ''
  video_mobile_mpeg4_amr_height: string // ''
  video_mobile_mpeg4_amr_size: number // 0
  video_mobile_mpeg4_amr_download: string // ''
  video_mobile_high_width: number // 320
  video_mobile_high_height: number // 180
  video_mobile_high_size: number // 176349
  video_mobile_high_download: string // '/7340/8278838/979c917e3dc0a0c9fa12c6c21a6d49b5/video_mobile_high/soundv5-1-7-video.mp4'
  audio_width: string // ''
  audio_height: string // ''
  audio_size: number // 86973
  audio_download: string // '/7340/8278838/979c917e3dc0a0c9fa12c6c21a6d49b5/audio/soundv5-1-7-audio.mp3'
  video_webm_360p_width: string // ''
  video_webm_360p_height: string // ''
  video_webm_360p_size: number // 0
  video_webm_360p_download: string // ''
  video_webm_720p_width: string // ''
  video_webm_720p_height: string // ''
  video_webm_720p_size: number // 0
  video_webm_720p_download: string // ''
  video_original_width?: number // 1920
  video_original_height?: number // 1080
  video_original_size: number // 3107024
  video_original_download: string // '/7340/8278838/979c917e3dc0a0c9fa12c6c21a6d49b5/video_original/download-video.mp4'
  live_start_time: string // '2022-12-13 16:19:10+00'
  changeme: string // ''
  content: string // ''
  content_text: string | number // ''
  before_download_type: string // ''
  before_link: string // ''
  before_download_url: string // ''
  after_download_type: string // ''
  after_link: string // ''
  after_download_url: string // ''
  after_text: string // ''
  tags: string[]
}

type DetailedVideoDTO = VideoDTO & {
  referer_count_fmt: string
  search_string_match_reason: string
  number_of_clips: number
  live_name: string
  token_upload_name: string
  token_upload_email: string
}

type Video = {
  id: number
  token: string
  treeId: number
  protectedToken?: string
  title: string
  description: string
  descriptionHTML: string
  thumbnailOriginal: string
  thumbnailQuad16: string
  thumbnailQuad50: string
  thumbnailQuad75: string
  thumbnailQuad100: string
  thumbnailPortrait: string
  thumbnailSmall: string
  thumbnailMedium: string
  thumbnailStandard: string
  thumbnailLarge: string
  previewFrames: string
  previewFramesCount: number
  previewFramesWidth: number
  previewFramesHeight: number
  durationSeconds: number
  durationSecondsFloat: number
  durationMilliseconds: number
  categoryId: number
  categoryName: string
  creationDate: Date
  creationDateFmt: string | undefined
  viewCount: number
  hasSubtitles: boolean
  isPublished: boolean
  publishDate: Date | undefined
  publishDateFmt: string | undefined
  isDeleted: boolean
  publicPath: string
  isPlaceholder: boolean
  durationFormatted: string
  protectionMethod: string
  isEncoded: boolean
  isPromoted: boolean
  width: number
  height: number
  aspectRatio: number
  protectionPassword?: string
  protectionIndividualCountries?: boolean // false
  protectionCountries: string[] // ""
  protectionEndpoint?: string // ''
  protectionAvailableDate?: string // ''
  protectionAvailableDateEpoch?: number // 0
  protectionAvailableMessage?: string // ''
  protectionWarningDate?: string // ''
  protectionWarningDateEpoch?: number // 0
  protectionWarningMessage?: string // ''
  protectionExpirationDate?: string // ''
  protectionExpirationDateEpoch?: number // 0
  protectionExpirationMessage?: string // ''
  webinarId: number
  originalFileName: string
  absoluteUrl: string
  tags: string[]
  videoFields: Record<string, unknown>
  is360Degree: boolean
  has360DegreeThumbnail: boolean
  mediumDownload?: string
  thumbnail?: string
}

const mapDTOtoVideo = (dto: VideoDTO): Video => {
  if (dto === undefined) {
    return {
      id: -1,
      treeId: -1,
      title: 'This video has been deleted',
      description: '',
      descriptionHTML: '',
      token: '',
      protectedToken: '',
      thumbnailOriginal: '',
      thumbnailQuad16: '',
      thumbnailQuad50: '',
      thumbnailQuad75: '',
      thumbnailQuad100: '',
      thumbnailPortrait: '',
      thumbnailSmall: '',
      thumbnailMedium: '',
      thumbnailStandard: '',
      thumbnailLarge: '',
      previewFrames: '',
      previewFramesCount: 0,
      previewFramesHeight: 0,
      previewFramesWidth: 0,
      durationSeconds: 0,
      durationSecondsFloat: 0.0,
      durationMilliseconds: 0,
      categoryId: 0,
      categoryName: '',
      creationDate: new Date(),
      creationDateFmt: '',
      viewCount: 0,
      hasSubtitles: false,
      isPublished: false,
      publishDate: undefined,
      publishDateFmt: undefined,
      isDeleted: true,
      publicPath: '',
      isPlaceholder: false,
      durationFormatted: '',
      protectionMethod: '',
      isEncoded: false,
      isPromoted: false,
      width: 0,
      height: 0,
      aspectRatio: 1,
      protectionPassword: '',
      protectionIndividualCountries: false,
      protectionCountries: [],
      protectionEndpoint: '',
      protectionAvailableDate: '',
      protectionAvailableDateEpoch: 0,
      protectionAvailableMessage: '',
      protectionWarningDate: '',
      protectionWarningDateEpoch: 0,
      protectionWarningMessage: '',
      protectionExpirationDate: '',
      protectionExpirationDateEpoch: 0,
      protectionExpirationMessage: '',
      webinarId: 0,
      originalFileName: '',
      absoluteUrl: '',
      tags: [],
      videoFields: {},
      is360Degree: false,
      has360DegreeThumbnail: false,
      mediumDownload: '',
      thumbnail: '',
    }
  }

  return {
    id: dto.photo_id,
    treeId: dto.tree_id,
    token: dto.token,
    protectedToken: dto.protected_token || undefined,
    title: dto.title,
    description: String(dto.content_text),
    descriptionHTML: dto.content,
    thumbnailOriginal: dto.original_download,
    thumbnailQuad16: dto.quad16_download,
    thumbnailQuad50: dto.quad50_download,
    thumbnailQuad75: dto.quad75_download,
    thumbnailQuad100: dto.quad100_download,
    thumbnailPortrait: dto.portrait_download,
    thumbnailSmall: dto.small_download,
    thumbnailMedium: dto.medium_download,
    thumbnailStandard: dto.standard_download,
    thumbnailLarge: dto.large_download,
    previewFrames: dto.video_frames_download,
    previewFramesCount: Math.ceil(
      dto.video_length_float / Math.ceil(dto.video_length_float / 200)
    ),
    previewFramesWidth: dto.video_frames_width,
    previewFramesHeight: dto.video_frames_height,
    durationSeconds: dto.video_length,
    durationSecondsFloat: dto.video_length_float,
    durationMilliseconds: dto.video_length_float * 1000,
    categoryId: dto.album_id,
    categoryName: dto.album_title,
    creationDate: new Date(dto.creation_date_epoch),
    creationDateFmt: dto.creation_date_epoch
      ? `${dto.creation_date__date} ${dto.creation_date__time}`
      : undefined,
    viewCount: dto.view_count,
    hasSubtitles: dto.subtitles_p,
    isPublished: dto.published_p,
    publishDate: dto.publish_date_epoch
      ? new Date(+dto.publish_date_epoch * 1000)
      : undefined,
    publishDateFmt: dto.publish_date_epoch
      ? `${dto.publish_date__date} ${dto.publish_date__time}`
      : undefined,
    isDeleted: false,
    publicPath: dto.one,
    isPlaceholder: dto.placeholder_p,
    durationFormatted: dto.video_length_fmt,
    protectionMethod: dto.protection_method,
    isEncoded: dto.video_encoded_p,
    isPromoted: dto.promoted_p,
    width: dto.video_original_width ?? dto.original_width,
    height: dto.video_original_height ?? dto.original_height,
    aspectRatio: dto.original_width / dto.original_height,
    protectionPassword: dto.protection_password,
    protectionIndividualCountries: dto.protection_individual_countries_p,
    protectionCountries: !dto.protection_countries
      ? []
      : dto.protection_countries.split(' '),
    protectionEndpoint: dto.protection_endpoint,
    protectionAvailableDate: dto.protection_available_date,
    protectionAvailableDateEpoch: dto.protection_available_date_epoch,
    protectionAvailableMessage: dto.protection_available_message,
    protectionWarningDate: dto.protection_warning_date,
    protectionWarningDateEpoch: dto.protection_warning_date_epoch,
    protectionWarningMessage: dto.protection_warning_message,
    protectionExpirationDate: dto.protection_expiration_date,
    protectionExpirationDateEpoch: dto.protection_expiration_date_epoch,
    protectionExpirationMessage: dto.protection_expiration_message,
    webinarId: dto.live_id,
    originalFileName: dto.original_filename,
    absoluteUrl: dto.has_external_url_p ? dto.absolute_url : '',
    tags: dto.tags,
    is360Degree: dto.video_360_p,
    has360DegreeThumbnail: dto.thumbnail_360_p,
    videoFields: {
      ...dto,
    },
    mediumDownload: dto.video_medium_download,
    thumbnail: dto.medium_download,
  }
}

export { type VideoDTO, type DetailedVideoDTO, type Video, mapDTOtoVideo }
